import request from '@/utils/request.js'
import main from '@/main'

const basePath = '/Function/Guide/';

const state = {
  TaskType: {
    0: "接团",
    1: "送团",
    2: "全陪"
  }
};

const mutations = {};

const actions = {

  CheckTeamOrder({commit}, view) {
    return request.PromiseCall(basePath, 'CheckTeamOrder', view);
  },
  Get({commit}, view) {
    return request.PromiseCall(basePath, 'Get', view);
  },
  Check({commit}, view) {
    return request.PromiseCall(basePath, 'Check', view);
  },


};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Function/Guide/index.js